module.exports = __webpack_public_path__ + "img/pmp.a4f4de09.svg";